import { render } from "./ViewUsersModal.vue?vue&type=template&id=0995bb6b"
import script from "./ViewUsersModal.vue?vue&type=script&lang=ts"
export * from "./ViewUsersModal.vue?vue&type=script&lang=ts"
script.render = render

export default script